module.exports = __webpack_public_path__ + "media/celeste_home.3de2d3fd.wav";